var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blur-card",style:({
        backdropFilter: ("blur(60px) brightness(" + (_vm.$vuetify.theme.dark ? '70' : '130') + "%) saturate(130%)"),
        boxShadow: ("0 15px 40px 0 rgba(" + (_vm.$vuetify.theme.dark ? '100,100,100' : '0,0,0') + ", 0.3)"),
        backgroundImage: ("linear-gradient(transparent, rgba(" + (_vm.$vuetify.theme.dark ? '50,50,50' : '255,255,255') + ", 0.4))"),
    })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }